module.exports = __webpack_public_path__ + "img/default.ebbf921f.png";